import {
  // tokens,
  makeStyles,
  // makeResetStyles,
  shorthands,
} from '@fluentui/react-components';

// override default styles for landing pages
export const useCustomLandingPageStyles = makeStyles({
  landingPageComponentRoot: {
    backgroundColor: 'darkred',
    width: '100%',
    height: '200px',
    ...shorthands.margin('50px'),
  },
  landingPageComponentTitle: {
    backgroundColor: 'lightyellow',
  },
});
